export default {
    "name": "HomePurchaseOrders",
    "kind": "HoudiniQuery",
    "hash": "99ff96c6c7d3c27ef8dd5919b0ac9e7cc0e1bff455720e4a7e221190a0fbc0e0",

    "raw": `query HomePurchaseOrders($filter: PurchaseOrderFilter) {
  purchaseOrders(filter: $filter) {
    items {
      doneReceiving
      finalized
      total
      receivedPercent
      date
      store {
        id
        code
        name
      }
      salesPerson {
        name
        id
      }
      internalComments
      type
      purchaseOrderId
      vendor {
        name
        id
      }
      totalQuantityReceived
      id
    }
  }
}
`,

    "rootType": "Query",
    "stripVariables": [],

    "selection": {
        "fields": {
            "purchaseOrders": {
                "type": "PurchaseOrderList",
                "keyRaw": "purchaseOrders(filter: $filter)",

                "selection": {
                    "fields": {
                        "items": {
                            "type": "PurchaseOrder",
                            "keyRaw": "items",

                            "selection": {
                                "fields": {
                                    "doneReceiving": {
                                        "type": "Boolean",
                                        "keyRaw": "doneReceiving",
                                        "visible": true
                                    },

                                    "finalized": {
                                        "type": "Boolean",
                                        "keyRaw": "finalized",
                                        "visible": true
                                    },

                                    "total": {
                                        "type": "String",
                                        "keyRaw": "total",
                                        "visible": true
                                    },

                                    "receivedPercent": {
                                        "type": "String",
                                        "keyRaw": "receivedPercent",
                                        "visible": true
                                    },

                                    "date": {
                                        "type": "Date",
                                        "keyRaw": "date",
                                        "visible": true
                                    },

                                    "store": {
                                        "type": "Store",
                                        "keyRaw": "store",

                                        "selection": {
                                            "fields": {
                                                "id": {
                                                    "type": "UInt",
                                                    "keyRaw": "id",
                                                    "visible": true
                                                },

                                                "code": {
                                                    "type": "String",
                                                    "keyRaw": "code",
                                                    "visible": true
                                                },

                                                "name": {
                                                    "type": "String",
                                                    "keyRaw": "name",
                                                    "visible": true
                                                }
                                            }
                                        },

                                        "visible": true
                                    },

                                    "salesPerson": {
                                        "type": "UserAccount",
                                        "keyRaw": "salesPerson",
                                        "nullable": true,

                                        "selection": {
                                            "fields": {
                                                "name": {
                                                    "type": "String",
                                                    "keyRaw": "name",
                                                    "visible": true
                                                },

                                                "id": {
                                                    "type": "Int",
                                                    "keyRaw": "id",
                                                    "visible": true
                                                }
                                            }
                                        },

                                        "visible": true
                                    },

                                    "internalComments": {
                                        "type": "String",
                                        "keyRaw": "internalComments",
                                        "visible": true
                                    },

                                    "type": {
                                        "type": "String",
                                        "keyRaw": "type",
                                        "visible": true
                                    },

                                    "purchaseOrderId": {
                                        "type": "UInt",
                                        "keyRaw": "purchaseOrderId",
                                        "visible": true
                                    },

                                    "vendor": {
                                        "type": "Vendor",
                                        "keyRaw": "vendor",

                                        "selection": {
                                            "fields": {
                                                "name": {
                                                    "type": "String",
                                                    "keyRaw": "name",
                                                    "visible": true
                                                },

                                                "id": {
                                                    "type": "UInt",
                                                    "keyRaw": "id",
                                                    "visible": true
                                                }
                                            }
                                        },

                                        "visible": true
                                    },

                                    "totalQuantityReceived": {
                                        "type": "Decimal6",
                                        "keyRaw": "totalQuantityReceived",
                                        "visible": true
                                    },

                                    "id": {
                                        "type": "ID",
                                        "keyRaw": "id",
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        }
                    }
                },

                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {}
    },

    "input": {
        "fields": {
            "filter": "PurchaseOrderFilter"
        },

        "types": {
            "DateFilter": {
                "eq": "Date",
                "gt": "Date",
                "gte": "Date",
                "lt": "Date",
                "lte": "Date",
                "ne": "Date"
            },

            "UserAccountFilter": {
                "authorizedStores": "UInt",
                "id": "UInt",
                "isSalesPerson": "Boolean",
                "name": "String",
                "status": "UserAccountStatusEnum"
            },

            "StoreFilter": {
                "id": "UInt",
                "name": "String"
            },

            "PurchaseOrderFilter": {
                "date": "DateFilter",
                "doneReceiving": "Boolean",
                "pricesFinalized": "Boolean",
                "salesperson": "UserAccountFilter",
                "store": "StoreFilter",
                "storeId": "UInt",
                "vendorId": "UInt",
                "void": "Boolean"
            }
        },

        "defaults": {},
        "runtimeScalars": {}
    },

    "policy": "NetworkOnly",
    "partial": false
};

"HoudiniHash=32fed59c29e5684d16cc7638668f04c2b11b6ba014d24507492f1455c5f4c4bc";